import { AllieText } from '../../../Text';
import { LoadServerRowsProps, SortConfig, SortingProps } from '../../AllieDataGrid.types';
import { DataGridDownload } from '../DataGridDownload/DataGridDownload';
import { DataGridSort } from '../DataGridSort';
import {
  StyledDataGridTitle,
  StyledDataGridToolbar,
  StyledDataGridSection,
} from './DataGridToolbar.styles';
import { Column } from '@tanstack/react-table';

interface DataGridToolbarProps {
  title?: string;
  children?: React.ReactNode;
  downloadQuery?: (params: LoadServerRowsProps) => any;
  downloadLabel?: string;
  /** Opt-in: offer CSV / XLS instead of a CSV-only download. Off by default. */
  enableXlsxDownload?: boolean;
  showTitle?: boolean;
  sortConfig?: SortConfig;
  columns: Column<any>[];
  onChangeSort: React.Dispatch<React.SetStateAction<SortingProps[]>>;
}

export const DataGridToolbar: React.FC<DataGridToolbarProps> = ({
  title,
  children,
  downloadQuery,
  downloadLabel,
  enableXlsxDownload,
  showTitle,
  sortConfig,
  columns,
  onChangeSort,
}) =>
  title || children || downloadQuery ? (
    <StyledDataGridToolbar>
      <StyledDataGridSection>
        {title && showTitle && (
          <AllieText color="neutral-90" weight={500}>
            {title}
          </AllieText>
        )}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {children}
          {(downloadQuery || sortConfig?.showSort) && (
            <div style={{ display: 'flex' }}>
              {sortConfig?.showSort && (
                <DataGridSort
                  columns={columns}
                  onChange={onChangeSort}
                  labelSortBy={sortConfig.labelSortBy}
                  labelNoOrder={sortConfig.labelNoOrder}
                  labelAsc={sortConfig.labelAsc}
                  labelDesc={sortConfig.labelDesc}
                />
              )}
              {downloadQuery && (
                <DataGridDownload
                  query={downloadQuery}
                  title={title}
                  downloadLabel={downloadLabel}
                  enableXlsx={enableXlsxDownload}
                />
              )}
            </div>
          )}
        </div>
      </StyledDataGridSection>
    </StyledDataGridToolbar>
  ) : (
    <></>
  );
